export default __webpack_public_path__ + "static/media/labra-lightblue.72dc8af3.svg";